define('shared/initializer/form/newHouseAdapters/PaymentMethodUpdate',[ 
    'shared/lib/ctor', 
    'shared/lib/RSVP',
    '../adapters/Bootstrap3',
    '../adapters/mixins/fields/Location',
    '../adapters/mixins/SubmissionLockable',
    '../adapters/mixins/LabelFloatable',
    '../adapters/mixins/Redirectable',
    '../adapters/mixins/ThrobberOnBeforeSubmit',
    '../adapters/mixins/AfterSubmitActionTriggerable',
    '../adapters/mixins/InputValuePersistable',
    '../adapters/mixins/InputValueRecoverable'
], 
function ( 
    ctor, 
    RSVP, 
    Bootstrap3,
    LocationField,
    SubmissionLockable,
    LabelFloatable,
    Redirectable,
    ThrobberOnBeforeSubmit,
    AfterSubmitActionTriggerable,
    InputValuePersistable,
    InputValueRecoverable
) {
    'use strict';

    var Ctor = ctor(function() {
        console.log('payment init');
        var me = this;
        me.base.apply(me, arguments);

        me.mixin(
            LocationField,
            SubmissionLockable,
            LabelFloatable,
            Redirectable,
            ThrobberOnBeforeSubmit,
            AfterSubmitActionTriggerable,
            InputValuePersistable,
            InputValueRecoverable
        );
    }).inherit(Bootstrap3); 

    return Ctor;
});
